import { useCallback } from 'react';

import type { AnyObject } from '../../../../../types';
import { bridge } from '../../../../../utils';

type LogClickFilterParams = {
  selectedItem?: string;
  itemLogging?: AnyObject;
  /** 이벤트명 — 기본 CLICK_FILTER, sub_radio는 CLICK_SUB_FILTER */
  eventName?: string;
};

export const useLogClickFilter = (logging: AnyObject) => {
  return useCallback(
    ({ selectedItem, itemLogging, eventName = 'CLICK_FILTER' }: LogClickFilterParams) => {
      bridge.logAnalyticsEvent({
        name: eventName,
        ably_only_log: {
          ...logging.ably_only_log,
          ...itemLogging?.ably_only_log,
        },
        analytics: {
          ...logging.analytics,
          ...itemLogging?.analytics,
          ...(selectedItem != null && { SELECTED_ITEM: selectedItem }),
        },
      });
    },
    [logging],
  );
};
